import { useState } from "react";
import { AdminTitle, Spinner } from "@/admin/AdminLayout";
import { useList } from "@/admin/hr/common";

function Bars({ title, items, testid }) {
  const max = Math.max(1, ...items.map(([, v]) => v));
  return (
    <section className="rounded-lg border border-zinc-200 bg-white p-5" data-testid={testid}>
      <h2 className="mb-4 text-sm font-bold text-zinc-900">{title}</h2>
      {items.length === 0 ? <p className="text-sm text-zinc-500">Veri yok.</p> : (
        <ul className="space-y-2.5">
          {items.map(([k, v]) => (
            <li key={k} className="text-sm">
              <div className="mb-1 flex justify-between"><span className="text-zinc-700">{k}</span><b>{v}</b></div>
              <div className="h-2 rounded-full bg-zinc-100"><div className="h-2 rounded-full bg-[color:var(--red)] transition-[width] duration-500" style={{ width: `${(v / max) * 100}%` }} /></div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}

export default function Reports() {
  const [f, setF] = useState({ date_from: "", date_to: "" });
  const [d] = useList("/admin/hr/reports", f);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <div>
      <AdminTitle title="Başvuru Raporları" desc={d ? `Seçilen dönemde ${d.total} başvuru (gerçek veritabanı kayıtları)` : ""}>
        <input type="date" value={f.date_from} onChange={set("date_from")} className="field-input !w-auto" aria-label="Başlangıç" data-testid="reports-from" />
        <input type="date" value={f.date_to} onChange={set("date_to")} className="field-input !w-auto" aria-label="Bitiş" data-testid="reports-to" />
      </AdminTitle>
      {!d ? <Spinner /> : (
        <div className="grid gap-4 lg:grid-cols-2">
          <Bars title="Başvuru durumuna göre" items={d.by_status} testid="report-status" />
          <Bars title="Kimlik kartı türüne göre" items={d.by_card} testid="report-card" />
          <Bars title="Aylara göre" items={d.by_month} testid="report-month" />
          <Bars title="Belge durumuna göre" items={d.by_docs} testid="report-docs" />
          <Bars title="İllere göre (ilk 15)" items={d.by_city} testid="report-city" />
          <Bars title="Başvurulan göreve göre" items={d.by_position} testid="report-position" />
          <Bars title="Başvuru kaynağına göre" items={d.by_source} testid="report-source" />
        </div>
      )}
    </div>
  );
}
